export default __webpack_public_path__ + "static/cam-turn-111b19fbaf44e7356bc64f9d8aa64702.png";